import React from 'react';
import { connect } from 'unistore/react';

import Modal from '../Modal';
import { modalActions } from '@utils/store/actions';

const UniModal = ({ uniModal, __uniModalClose, uniModalProps }) => (
	<Modal
		openMoi={uniModal}
		modalClose={__uniModalClose}
		{...uniModalProps}
		id="uniModal"
		small
	/>
);

export default connect('uniModal, uniModalProps', modalActions)(UniModal);
